import type { EvaCaseView } from './evaCaseViews';

/**
 * The single status vocabulary shared by the worklist's summary chips and the status filter
 * dropdown — one entry per selectable status, in display order. `Eligible` covers cases EVA has
 * never touched (no `EvaDetails.Status` yet); every other entry matches the case's raw status.
 */
export interface EvaCaseStatusOption {
  value: string;
  label: string;
}

export const EVA_CASE_STATUS_OPTIONS: EvaCaseStatusOption[] = [
  { value: 'Eligible', label: 'Eligible' },
  { value: 'Queued', label: 'Queued' },
  { value: 'Running', label: 'Running' },
  { value: 'Waiting', label: 'Waiting' },
  { value: 'NeedsReview', label: 'Needs Review' },
  { value: 'Failed', label: 'Failed' },
  { value: 'Verified', label: 'Verified' },
  { value: 'HumanVerified', label: 'Human Verified' },
];

/** True when the row matches the selected status; an empty selection matches everything. */
export function matchesEvaCaseStatus(row: EvaCaseView, status: string): boolean {
  if (!status)
    return true;

  if (status === 'Eligible')
    return !row.status;

  return row.status === status;
}
